/**
 * Screen — обёртка экрана: колонка на всю высоту с safe-area, опциональные заголовок,
 * подзаголовок и футер.
 * Card — карточка. Row — строка «подпись / значение».
 * FallbackButton — нижняя кнопка для веба; в мессенджере скрыта (там нативная MainButton).
 */
import type { ReactNode } from "react";
import { tg } from "@/telegram/tg";
import { Button } from "@/components/Button";

type Props = {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export function Screen({ title, subtitle, children, footer }: Props) {
  return (
    <div className="flex min-h-dvh flex-col bg-surface-base px-5 pt-8 pb-[calc(env(safe-area-inset-bottom)+1.25rem)] text-white">
      {(title || subtitle) && (
        <header className="mb-6">
          {title && <h1 className="text-[26px] font-semibold leading-tight">{title}</h1>}
          {subtitle && <p className="mt-2 text-[15px] leading-snug text-white/55">{subtitle}</p>}
        </header>
      )}
      <main className="flex-1">{children}</main>
      {footer && <footer className="pt-4">{footer}</footer>}
    </div>
  );
}

export function Card({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div className={`rounded-2xl border border-white/[0.06] bg-surface-card p-4 ${className}`}>{children}</div>
  );
}

export function Row({ label, value, mono = false }: { label: string; value: ReactNode; mono?: boolean }) {
  return (
    <div className="flex items-start justify-between gap-3 py-2">
      <span className="text-[14px] text-white/45">{label}</span>
      <span className={`text-right text-[15px] ${mono ? "font-mono" : ""}`}>{value}</span>
    </div>
  );
}

export function FallbackButton(props: { text: string; onClick: () => void; disabled?: boolean; loading?: boolean }) {
  // в мессенджере (Telegram/WWChat) действие на нативной MainButton — веб-кнопку прячем
  if (typeof window !== "undefined" && tg()?.initData) return null;
  return (
    <Button className="mt-6" onClick={props.onClick} disabled={props.disabled || props.loading}>
      {props.loading ? "..." : props.text}
    </Button>
  );
}